import {connect} from "react-redux";
import {Modal} from "bootstrap";
import AppBaseComponent from '../../../../components/AppBaseComponent';
import HttpAPICall from "../../../../services/HttpAPICall";
import Loader from "../../../../components/ui/Loader/Loader";
import tapIcon from "../../../../services/TapIcon";
import { ORG_API_BASE_URL_2 } from "../../../../services/TapApiUrls";
import Ax from "../../../../components/hoc/Ax";
import {toast} from "react-toastify";


class GeneralSettings extends AppBaseComponent {

    constructor(props) {
        super(props);

        this.initGeneralConfigForm      =   {
            po_enable_tds                   :   'N',
            // po_enable_tcs                       :       'N',
            po_allow_po_for                 :   'Y',
            po_view_pending_qty             :   'Y',
            po_enable_authorized_signatory  :   'Y',
            po_enable_item_duedate          :   'N',
            po_display_manufacturer_po_pdf  :   'N',
            po_allow_backdate               :   'N',
            po_allow_edit_transaction_date  :   'Y',
            enable_po_timestamp_for_vendor  :   'N',
            po_enable_authorized_mobile     :   'N'
        };

        this.state                              =   {
            generalConfigloading                :      false,
            general_config_list                 :      null,
            generalConfigForm                   :     {...this.initGeneralConfigForm},
            editFormSubmiting                   :      false,
        };

        this.settingEditUrl =   ORG_API_BASE_URL_2  + '/setting_edit';
        this.settingUrl     =   ORG_API_BASE_URL_2  + '/settings';


        this.configData = [
            {  key: "po_enable_tds" ,                   value :"Enable TDS"},
            {  key: "po_allow_po_for",                  value :"Option to tag Asset/Workstation/Employee with Purchase Order"},
            {  key: "po_view_pending_qty",              value :"Include Item Pending Quantity in PDF" },
            {  key: "po_display_vendor_contact",        value :"Display Vendor Contact Details on Purchase Order"},
            {  key: "po_enable_authorized_signatory",   value :"Enable Authorized Signatory", child: [{ key: "po_enable_authorized_mobile", value :"Enable Authorized Signatory Mobile No." }]},
            {  key: "po_enable_item_duedate",           value :"Option to add Delivery Due Date for individual Items"},
            {  key: "po_display_manufacturer_po_pdf",   value :"Display manufacturer name in Purchase Order PDF" },
            {  key: "po_allow_backdate",                value :"Allow Purchase Order Creation on a Back date" },
            {  key: "po_allow_edit_transaction_date",   value :"Allow changing the Transaction Date while editing PO" },
            {  key: "enable_po_timestamp_for_vendor",   value :"Enable Timestamp for Vendor", child: [] },
            { key: "po_enable_delivery_date_required", value :"Mandatory delivery Date in voucher.", child: [] }
        ]

    }

    componentDidMount() {
        this.getGeneralSettingListing();
        this.editGeneralConfiguration        =        new Modal(document.getElementById('editGeneralConfigurationModal'), {keyboard: false, backdrop :false});
   }

    getGeneralSettingListing = () => {
        let params = {
            keys : ['po_allow_edit_transaction_date','po_enable_tds' ,'po_allow_po_for','po_view_pending_qty','po_enable_authorized_signatory','po_enable_item_duedate','po_display_manufacturer_po_pdf','po_allow_backdate','po_display_vendor_contact', 'enable_po_timestamp_for_vendor', 'po_enable_authorized_mobile', 'po_enable_delivery_date_required'],
        }
        this.setState({ generalConfigloading: true });
        HttpAPICall.withAthorization('GET', this.settingUrl, this.props.access_token, {...params}, {}, (resp) => {
            this.setState({ general_config_list: resp.data.data })
        }).then(() => this.setState({ generalConfigloading: false }));
    }

    editGeneralConfigurationInit = () => {
        this.editGeneralConfiguration.show();
        if(this.state.general_config_list) {
            let generalConfigForm = [];
            if (this.state.general_config_list) {
                Object.entries(this.state.general_config_list).forEach(([key, value]) => {
                  let name = key;
                  let val = value;
                  generalConfigForm[name] = val;
                });
              }
              
            this.setState({generalConfigForm})
        }
    }

    submitGeneralConfigurationForm        =    (e)          =>     {
        e.preventDefault();

        let formData        =   this.state.generalConfigForm;
        if(Object.keys(formData).includes('po_enable_authorized_signatory') && formData['po_enable_authorized_signatory'] === 'N') {
            formData        =   {...formData, po_enable_authorized_mobile : 'N'}   
        }
        this.setState({editFormSubmiting : true});
        HttpAPICall.withAthorization('PUT', this.settingEditUrl, this.props.access_token, {} , {...this.state.generalConfigForm} , (response) => {
            toast.success(response.data.msg, {position: toast.POSITION.TOP_RIGHT});
            this.editGeneralConfiguration.hide();
            this.getGeneralSettingListing();
        }).then(() => this.setState({editFormSubmiting: false}));
    }

    editGeneralConfigurationModalJsx      =    ()           =>     {
        return (
            <div className="modal fade" id="editGeneralConfigurationModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addAssetModalLabel">Edit General Configuration</h5>
                        </div>
                        <form onSubmit={this.submitGeneralConfigurationForm}>
                            <div className="modal-body p-3">
                                {this.configData.map((config) => (
                                    <>
                                    <div className="row align-items-center mb-2 mt-2 px-2" key={config.key}>
                                        <div className="col-md-9"><label className="form-label">{config.value}</label></div>
                                        <div className="col-md-1">
                                            <label>
                                                <input
                                                    type="radio"
                                                    name={config.key}
                                                    value="Y"
                                                    onChange={(e) => {
                                                        this.formInputHandler(e, "generalConfigForm")
                                                    }}
                                                    checked={this.state.generalConfigForm[config.key] == "Y"}
                                                /> Yes
                                            </label>
                                        </div>
                                        <div className="col-md-2">
                                            <label>
                                                <input
                                                    type="radio"
                                                    name={config.key}
                                                    value="N"
                                                    onChange={(e) => this.formInputHandler(e, "generalConfigForm")}
                                                    checked={this.state.generalConfigForm[config.key] == "N"} /> No
                                            </label>
                                        </div>
                                    </div>
                                    {
                                        config.key === 'po_enable_authorized_signatory' && this.state.generalConfigForm['po_enable_authorized_signatory'] === 'Y' &&
                                        config?.child?.map(ch => (
                                        <div className="row align-items-center mb-2 mt-2 px-2" key={ch.key}>
                                            <div className="col-md-9"><label className="form-label">{ch.value}</label></div>
                                            <div className="col-md-1">
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name={ch.key}
                                                        value="Y"
                                                        onChange={(e) => {
                                                            this.formInputHandler(e, "generalConfigForm")
                                                        }}
                                                        checked={this.state.generalConfigForm[ch.key] == "Y"}
                                                    /> Yes
                                                </label>
                                            </div>
                                            <div className="col-md-2">
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name={ch.key}
                                                        value="N"
                                                        onChange={(e) => this.formInputHandler(e, "generalConfigForm")}
                                                        checked={this.state.generalConfigForm[ch.key] == "N"} /> No
                                                </label>
                                            </div>
                                        </div>
                                        ))
                                    }
                                    </>
                                ))}                          
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" disabled={this.state.editFormSubmiting} data-bs-dismiss="modal">Close</button>
                                <button type="submit" className="btn btn-primary" disabled={this.state.editFormSubmiting} >Save {this.state.editFormSubmiting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : null}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
  }

    generalConfigurationJsx               =    ()           =>     {
        let data    =   this.state.general_config_list;
        return (<table className="table table-hover table-bordered my-4 ">
            <thead className="table-secondary">
                <tr className="text-center">
                    <th scope="col" style={{ width: "5%" }}>S.No</th>
                    <th scope="col" className="text-start">Configuration</th>
                    <th scope="col" style={{ width: "25%" }} >Value</th>
                </tr>
            </thead>
            <tbody>
                {this.configData.filter(config => {
                    if(!data || !Object.keys(data).includes(config.key)) return false;
                    return true;
                }).map((config, i)=> {
                    if(data && Object.keys(data).includes(config.key)) {
                            return <tr className="text-center" key={config.key}>
                                <td>{i + 1}</td>
                                <td className="text-start">
                                    {config.value}
                                    {
                                        config.key === 'po_enable_authorized_signatory' && data['po_enable_authorized_signatory'] === 'Y' && 
                                        <ul className="mt-2">
                                            {
                                                config?.child?.map(ch => (
                                                    <li key={ch.key}>{ch.value}</li>
                                                ))
                                            }
                                        </ul>
                                    }
                                </td>
                                <td>
                                    {data[config.key] == 'Y' ? "Yes" : "No"}
                                    {
                                        config.key === 'po_enable_authorized_signatory' && data['po_enable_authorized_signatory'] === 'Y' && 
                                        <ul className="list-unstyled mt-2">
                                            {
                                                config?.child.map(ch => (
                                                    <li key={ch.key}>{data[ch.key] === 'Y' ? 'Yes' : 'No'}</li>
                                                ))
                                            }
                                        </ul>
                                    }
                                </td>
                            </tr>
                        }
                    })}
            </tbody>
        </table>)
    }

    render                                  =     ()           =>     {
        return (<Ax>
            <div className="tab_content_wrapper mt-2"><span className="content_heading">General Configuration</span>
                <div className="text-end "><button className="btn btn-primary" disabled={!this.props.permissions.includes('isc-configuration-edit')}  onClick={this.editGeneralConfigurationInit}>Edit </button></div>
            </div>
            {this.state.generalConfigloading ? <Loader />
                : this.generalConfigurationJsx()}
            {this.editGeneralConfigurationModalJsx()}
            
        </Ax>);
    }

}


const mapStateToProps = state => {
    return {
        access_token            :        state.auth.access_token,
        permissions             :       state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : []
    };
};

export default connect(mapStateToProps)(GeneralSettings);